import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from "../../firebase"; 
import { collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import ProtectedComponent from '../../components/ProtectedComponent'; // Make sure this path is correct

function GroceryProductList() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        // This now correctly matches the collection you were fetching from.
        const querySnapshot = await getDocs(collection(db, 'MealsProducts'));
        const productsList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setProducts(productsList);
      } catch (err) {
        console.error("Error fetching products: ", err);
        setError('Failed to load products.');
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // --- CORRECTED DELETE FUNCTION ---
  const handleDelete = async (id, name) => {
    if (window.confirm(`Are you sure you want to delete the product "${name}"?`)) {
      try {
        // CORRECTION: The collection name now correctly matches the fetch query.
        await deleteDoc(doc(db, 'MealsProducts', id));
        setProducts(prevProducts => prevProducts.filter(product => product.id !== id));
        alert('Product deleted successfully!');
      } catch (err) {
        console.error("Error deleting product: ", err);
        alert('Failed to delete product.');
      }
    }
  };
  
  // --- UPDATED EDIT FUNCTION ---
  // Navigates to a dedicated edit page instead of opening a modal.
  const handleEdit = (productId) => {
    navigate(`/groceryproduct/edit/${productId}`);
  };

  if (loading) return <div style={styles.centered}>Loading products...</div>;
  if (error) return <div style={{ ...styles.centered, color: 'red' }}>{error}</div>;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2>Grocery Products</h2>
        {/* Button is now protected by a permission */}
        <ProtectedComponent requiredPermission="grocery_products.create">
          <button style={styles.addButton} onClick={() => navigate('/groceryproduct/add')}>
            <FaPlus style={{ marginRight: '8px' }} />
            Add Product
          </button>
        </ProtectedComponent>
      </div>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Image</th>
            <th style={styles.th}>Name</th>
            <th style={styles.th}>Price</th>
            <th style={styles.th}>Quantity</th>
            {/* --- UPDATED: 'Unit' is replaced with 'Category' --- */}
            <th style={styles.th}>Category</th>
            <th style={styles.th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.length > 0 ? (
            products.map(product => (
              <tr key={product.id}>
                <td style={styles.td}><img src={product.imageUrl} alt={product.name} style={styles.image} /></td>
                <td style={styles.td}>{product.name}</td>
                <td style={styles.td}>${product.price ? Number(product.price).toFixed(2) : '0.00'}</td>
                <td style={styles.td}>{product.quantity}</td>
                {/* --- UPDATED: Displaying categoryName from the product data --- */}
                <td style={styles.td}>{product.categoryName || 'N/A'}</td>
                <td style={styles.td}>
                  <ProtectedComponent requiredPermission="grocery_products.update">
                    <button style={{...styles.actionButton, ...styles.editButton}} onClick={() => handleEdit(product.id)}>
                      <FaEdit />
                    </button>
                  </ProtectedComponent>
                  <ProtectedComponent requiredPermission="grocery_products.delete">
                    <button style={{...styles.actionButton, ...styles.deleteButton}} onClick={() => handleDelete(product.id, product.name)}>
                      <FaTrash />
                    </button>
                  </ProtectedComponent>
                </td>
              </tr>
            ))
          ) : (
            <tr><td colSpan="6" style={styles.centered}>No products found.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

// --- STYLES ---
const styles = {
  container: { padding: '2rem', maxWidth: '1000px', margin: '0 auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' },
  addButton: { display: 'flex', alignItems: 'center', padding: '10px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px' },
  table: { width: '100%', borderCollapse: 'collapse', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
  th: { backgroundColor: '#f8f9fa', padding: '12px', border: '1px solid #ddd', textAlign: 'left' },
  td: { padding: '12px', border: '1px solid #ddd', verticalAlign: 'middle' },
  image: { width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' },
  actionButton: { border: 'none', padding: '8px 12px', borderRadius: '5px', cursor: 'pointer', color: 'white', marginRight: '5px' },
  editButton: { backgroundColor: '#28a745' },
  deleteButton: { backgroundColor: '#dc3545' },
  centered: { textAlign: 'center', padding: '20px', fontSize: '18px' },
};

export default GroceryProductList;